import { MostRecentTransactionsCard } from '@/components/organisms';
import TrendingYieldBearingAssetsCard from '@/components/organisms/TrendingYieldBearingAssets/TrendingYieldBearingAssetsCard';
import YieldBearingAssetInvestmentActionsCard from '@/components/organisms/YieldBearingAssetInvestmentActions/YieldBearingAssetInvestmentActionsCard';
import YieldBearingAssetPerformanceDetailCard from '@/components/organisms/YieldBearingAssetPerformanceDetail/YieldBearingAssetPerformanceDetailCard';
import { NavigationProvider } from '@/components/providers';
import APP_CONFIG from '@/config/app';
import { TRANSACTIONS } from '@/utils/strings';
import React from 'react';
const visualizeElementsAndSpacing = false;
const borderClassToVisualizeElementsAndSpacing = visualizeElementsAndSpacing
  ? 'border-white border'
  : '';
const spacingConfig = {
  gap: `gap${APP_CONFIG.STYLES.MAIN_PADDING}`,
  columnGap: `gap${APP_CONFIG.STYLES.MAIN_PADDING}`,
};
const roundednessConfig = {
  roundedness: `rounded${APP_CONFIG.STYLES.MAIN_ROUNDEDNESS}`,
};
const YieldBearingAssetDetailTemplate: React.FC<{ ticker: string }> = ({
  ticker,
}) => {
  return (
    <div
      key={ticker}
      className={`grid grid-cols-5 auto-rows-max grid-auto-flow-column 
        ${spacingConfig.gap} 
        ${roundednessConfig.roundedness} 
        ${borderClassToVisualizeElementsAndSpacing}`}
    >
      <div
        className={`col-span-3 flex flex-col 
          ${spacingConfig.columnGap} 
          ${borderClassToVisualizeElementsAndSpacing}`}
      >
        <YieldBearingAssetPerformanceDetailCard ticker={ticker} />
        <MostRecentTransactionsCard
          yieldBearingAssetTicker={ticker}
          cardTitle={
            TRANSACTIONS.CARD_HEADER_WHEN_SHOWING_YIELD_BEARING_ASSET_SPECIFIC_TRANSACTIONS
          }
        />
      </div>
      <div
        className={`col-span-2 flex flex-col 
          ${spacingConfig.columnGap} 
          ${borderClassToVisualizeElementsAndSpacing}`}
      >
        <NavigationProvider initialScreen="deposit-initial">
          <YieldBearingAssetInvestmentActionsCard ticker={ticker} />
        </NavigationProvider>
        <TrendingYieldBearingAssetsCard />
      </div>
    </div>
  );
};
export default YieldBearingAssetDetailTemplate;
